import { createGate } from "effector-react";

export const PlansModalGate = createGate();
